// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220026/js/" + chunkId + "." + {"44":"c4925e19","225":"6f7c4c5e","481":"f988c359","486":"a67a518e","770":"2f3e6ef0"}[chunkId] + ".0.6364885354843216.chunk.js";
};